/**
 * reveal.js - scroll-reveal for redaktionelt indhold (KCA Motion Guidelines 3.4).
 *
 * ÉN dokument-bred IntersectionObserver for hele siden: elementer med
 * [data-reveal] faar [data-in] naar de rammer viewporten, hvorefter CSS
 * (base.css) overtager toningen og observeren kobler elementet af (fyrer én
 * gang pr. session). Ingen scroll-listeners, ingen rAF-loops - JS saetter kun
 * et attribut, al timing/easing bor i CSS.
 *
 * Loades PER SECTION (<script type='module' src='reveal.js'>) fra de sektioner
 * der har reveal-indhold. ES-moduler evalueres én gang pr. URL, saa uanset hvor
 * mange sektioner loader det, findes der praecis ÉN observer og ÉN
 * section:load-listener (buildless singleton).
 *
 * Progressive enhancement: hviletilstanden (opacity:0) er i CSS gated bag
 * html.js (sat pre-paint i theme.liquid). Uden JS er indhold fuldt synligt.
 * Reduced motion + manglende IntersectionObserver + theme-editor: alt afsloeres
 * straks, saa intet nogensinde staar usynligt.
 */

const REVEAL = '[data-reveal]:not([data-in])';

// threshold 0 (ikke .2): sektioner hoejere end viewporten kan aldrig naa en
// hoej intersection-ratio - rootMargin trigger'er dem lige foer bunden i stedet.
const IO_OPTIONS = { threshold: 0, rootMargin: '0px 0px -10% 0px' };

const reveal = (el) => {
  el.dataset.in = '';
};

const revealAll = (root = document) => {
  root.querySelectorAll(REVEAL).forEach(reveal);
};

const prefersReduced = window.matchMedia('(prefers-reduced-motion: reduce)').matches;
const inEditor = window.Shopify && window.Shopify.designMode;
const canObserve = 'IntersectionObserver' in window && !prefersReduced;

let observer = null;

if (canObserve) {
  observer = new IntersectionObserver((entries, obs) => {
    for (const entry of entries) {
      if (!entry.isIntersecting) continue;
      reveal(entry.target);
      obs.unobserve(entry.target); // én gang - hold 0 observers i ro bagefter
    }
  }, IO_OPTIONS);
}

// Foerste pass uden -10%-baand: det der ALLEREDE er i viewporten ved load skal
// ikke vente paa scroll. Ellers staar kort der ligger i de nederste 10% af en
// lille skaerm (fx featured-collection under heroen paa mobil) usynlige,
// indtil brugeren scroller. IO leverer altid en foerste entry pr. target, saa
// callbacken afgoer hvert element én gang og overdrager resten til `observer`.
const INITIAL_OPTIONS = { threshold: 0, rootMargin: '0px' };

const scan = (root = document) => {
  // I editoren afsloeres alt straks, saa nyindsatte sektioner aldrig staar
  // usynlige mens redaktoeren arbejder.
  if (!observer || inEditor) {
    revealAll(root);
    return;
  }
  const initial = new IntersectionObserver((entries, obs) => {
    for (const entry of entries) {
      obs.unobserve(entry.target);
      if (entry.isIntersecting) reveal(entry.target);
      else observer.observe(entry.target);
    }
  }, INITIAL_OPTIONS);
  root.querySelectorAll(REVEAL).forEach((el) => initial.observe(el));
};

scan();

// Theme-editor: en tilfoejet/flyttet sektion faar sine egne reveal-elementer
// scannet (observeren har allerede unobserve'et de gamle).
document.addEventListener('shopify:section:load', (event) => scan(event.target));

// Signalér at modulet naaede at koere. theme.liquids load-failsafe laeser flaget:
// fejler dette modul (404/throw) foer her, forbliver flaget falsk, og failsafen
// afsloerer alt indhold - saa en modul-fejl aldrig strander [data-reveal] paa
// opacity:0 (html.js-gaten er ellers kun koblet fra herfra). Sat SIDST.
window.__kcaRevealReady = true;
